import React from "react";
import { Box, Grid } from '@mui/material';
import classes from "./controls.module.scss";
import {useNavigate} from "react-router-dom";
import { CheckIsUserAdmin } from "../../Shared/Utill/Utills";

const AdminControlsPage = () => {
    const navigate = useNavigate();
    CheckIsUserAdmin();

    return(<div className={classes.pagemargin}>
            <div className={classes.pagetitle} >Controls</div>
            <div className={classes.pagesubtitle}>Select the application you want to manage. </div>
            <Grid container spacing={2} >
            <Grid key={1} item xs={3}>
                <Box className={classes.tilebtn} onClick={() => navigate("/controls/specialeventscontrols")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Special Event Controls</div>
                    <div className={classes.textbtnsubtitle}>Everything you need to manage special events.</div>
                </Box>
             </Grid>
             <Grid key={2} item xs={3}>
                <Box className={classes.tilebtn} onClick={() => navigate("/controls/availabilityapplicationcontrols")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Availability Application Controls</div>
                    <div className={classes.textbtnsubtitle}>Controls for managing colleague availability.</div>
                </Box>
             </Grid>
             
             {/*<Grid key={3} item xs={3}>
                <Box className={classes.tilebtn} onClick={() => navigate("/controls/apponoff")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>On / Off Controls</div>
                    <div className={classes.textbtnsubtitle}>Switch applications on and off as you need them.</div>
                </Box>
             </Grid> */}
            </Grid>
            </div>); 
}

export default AdminControlsPage;